import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { userHistoryApi } from "../../http/http";
import { isFresh } from "../cacheUtils";

const TTL_MS = 1000 * 60 * 2; // 2 min

export const fetchUserHistory = createAsyncThunk(
  "userHistory/fetchUserHistory",
  async (token) => {
    if (!token) throw new Error("Missing auth token");
    const res = await userHistoryApi(token);
    return res?.data?.result || [];
  },
  {
    condition: (token, { getState }) => {
      const state = getState().userHistory;
      if (!token) return false;
      if (state.token && state.token !== token) return true;
      return !isFresh(state.lastFetched, TTL_MS);
    },
  }
);

const userHistorySlice = createSlice({
  name: "userHistory",
  initialState: {
    token: null,
    history: [],
    status: "idle",
    error: null,
    lastFetched: null,
  },
  reducers: {
    clearUserHistory(state) {
      state.token = null;
      state.history = [];
      state.status = "idle";
      state.error = null;
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserHistory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchUserHistory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.history = action.payload;
        state.token = action.meta.arg;
        state.lastFetched = Date.now();
      })
      .addCase(fetchUserHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Failed to load user history";
      });
  },
});

export const { clearUserHistory } = userHistorySlice.actions;
export default userHistorySlice.reducer;

